'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _variables = require('../../style/variables');

var _variables2 = _interopRequireDefault(_variables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var animateStates = {
    WILLCLOSE: 'willClose',
    CLOSING: 'closing',
    DIDCLOSE: 'didClose',
    CALCULATING: 'calculating',
    WILLOPEN: 'willOpen',
    OPENING: 'opening',
    DIDOPEN: 'didOpen'
};

/*
  working principle:
    if children in props aren't null or undefined:
            - calculating opens component to height auto and moving it off the screen and getting it's height;
            - willOpen closing component to 0 or minHeight from props;
            - opening animating component using transition;
            - didOpen being set from transitionEnd handler after
              opening and setting component's height from fixed to auto.
        if component is open:
            nothing happened, height auto automatically calculates component's height

    if children in nextProps are null or undefined:
        if component is open:
            - willClose height: auto - needed for current animate state checking
            - closing calculating current component's height and setting it instead of height auto
            - didClose animating co
        если компонент закрыт:
            ничего не происходит
 */

/*
  принцип работы:
    если children приходят в пропсах:
        если компонент закрыт:
            - calculating открывает компонент полностью с переводом в position absolute и выводом за 9999px с экрана
            - willOpen закрывает компонент до 0 либо minSize (props)
            - opening анимирует компонент с помощью transition
            - didOpen срабатывает после transition и ставит высоту элемента в auto вместо статической
        если компонент открыт:
            ничего не происходит, height: auto сам пересчитывает высоту компонента

    если children не приходят в пропсах:
        если компонент открыт:
            - didOpen height: auto
            - closing просчитывает высоту компонента из предыдущего стейта и ставит ее вместо height: 'auto'
            - didClose анимирует закрытие компонента до 0 либо minSize
        если компонент закрыт:
            ничего не происходит
 */

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;

        _this.startAnimationHelper = function () {
            return new Promise(function (resolve) {
                requestAnimationFrame(resolve);
            });
        };

        _this.setContentRef = function (el) {
            return _this._contentRef = el;
        };

        _this._uiWillOpen = function (state) {
            _this._callLifecycleCallback(_this.animateStates.WILLOPEN);
            return _this.startAnimationHelper().then(function () {
                return _this.setState(Object.assign({
                    animateState: _this.animateStates.WILLOPEN
                }, state));
            });
        };

        _this._uiWillClose = function (state) {
            _this._callLifecycleCallback(_this.animateStates.WILLCLOSE);
            return _this.setState(Object.assign({
                animateState: _this.animateStates.WILLCLOSE
            }, state));
        };

        _this._uiOpening = function (state) {
            _this._callLifecycleCallback(_this.animateStates.OPENING);
            return _this.startAnimationHelper().then(function () {
                return _this.setState(Object.assign({
                    animateState: _this.animateStates.OPENING
                }, state));
            });
        };

        _this._uiDidOpen = function (state) {
            _this._callLifecycleCallback(_this.animateStates.DIDOPEN);
            return _this.setState(Object.assign({
                animateState: _this.animateStates.DIDOPEN
            }, state));
        };

        _this._uiDidClose = function (state) {
            _this._callLifecycleCallback(_this.animateStates.DIDCLOSE);
            return _this.setState(Object.assign({
                animateState: _this.animateStates.DIDCLOSE
            }, state));
        };

        _this._uiClosing = function (state) {
            _this._callLifecycleCallback(_this.animateStates.CLOSING);
            return _this.setState(Object.assign({
                animateState: _this.animateStates.CLOSING
            }, state));
        };

        _this._uiCalculate = function (state) {
            return _this.startAnimationHelper().then(function () {
                return _this.setState(Object.assign({
                    animateState: _this.animateStates.CALCULATING
                }, state));
            });
        };

        _this._isUiDidClose = function () {
            return _this.state.animateState === _this.animateStates.DIDCLOSE;
        };

        _this._isUiClosing = function () {
            return _this.state.animateState === _this.animateStates.CLOSING;
        };

        _this._isUiDidOpen = function () {
            return _this.state.animateState === _this.animateStates.DIDOPEN;
        };

        _this._isUiCalculating = function () {
            return _this.state.animateState === _this.animateStates.CALCULATING;
        };

        _this._isUiWillOpen = function () {
            return _this.state.animateState === _this.animateStates.WILLOPEN;
        };

        _this._isUiWillClose = function () {
            return _this.state.animateState === _this.animateStates.WILLCLOSE;
        };

        _this._isUiOpening = function () {
            return _this.state.animateState === _this.animateStates.OPENING;
        };

        _this._isUiOpen = function () {
            return _this._isUiDidOpen() || _this._isUiWillOpen || _this._isUiOpening;
        };

        _this._isUiClose = function () {
            return _this._isUiDidClose() || _this._isUiClosing() || _this._isUiWillClose();
        };

        _this.getHeight = function () {
            if (_this._contentRef) {
                return _this._contentRef.offsetHeight;
            }
            return null;
        };

        _this.getWidth = function () {
            if (_this._contentRef) {
                return _this._contentRef.offsetWidth;
            }
            return null;
        };

        _this.calculateAndClose = function () {
            return _this._uiWillClose({
                height: _this.getHeight()
            }).then(function () {
                return _this._uiClosing();
            });
        };

        _this.calculateAndOpen = function () {
            return _this._uiCalculate().then(function () {
                return _this._uiWillOpen({
                    height: _this.getHeight()
                });
            }).then(_this._uiOpening);
        };

        _this.handleTransitionEnd = function (e) {
            if (e.target === _this._contentRef) {
                if (_this._isUiOpening()) {
                    _this._uiDidOpen();
                } else if (_this._isUiClosing()) {
                    _this._uiDidClose();
                }
            }
        };

        _this._callLifecycleCallback = function (state) {
            var animateState = _this.state.animateState,
                _this$props = _this.props,
                onEnter = _this$props.onEnter,
                onEntering = _this$props.onEntering,
                onEntered = _this$props.onEntered,
                onExit = _this$props.onExit,
                onExiting = _this$props.onExiting,
                onExited = _this$props.onExited,
                animateStates = _this.animateStates;


            animateState = state || animateState;

            switch (animateState) {
                case animateStates.WILLOPEN:
                    if (typeof onEnter === 'function') {
                        onEnter();
                    }
                    break;
                case animateStates.OPENING:
                    if (typeof onEntering === 'function') {
                        onEntering();
                    }
                    break;
                case animateStates.DIDOPEN:
                    if (typeof onEntered === 'function') {
                        onEntered();
                    }
                    break;
                case animateStates.WILLCLOSE:
                    if (typeof onExit === 'function') {
                        onExit();
                    }
                    break;
                case animateStates.CLOSING:
                    if (typeof onExiting === 'function') {
                        onExiting();
                    }
                    break;
                case animateStates.DIDCLOSE:
                    if (typeof onExited === 'function') {
                        onExited();
                    }
                    break;
            }
        };

        _this.getWrapperStyles = function () {
            var _this$props2 = _this.props,
                timeout = _this$props2.timeout,
                easing = _this$props2.easing,
                minSize = _this$props2.minSize,
                style = _this$props2.style,
                removeOnCalc = _this$props2.removeOnCalc,
                _this$state = _this.state,
                animateState = _this$state.animateState,
                height = _this$state.height,
                animateStates = _this.animateStates,
                wrapperStyle = Object.assign({
                height: 0,
                transition: 'height ' + timeout + 'ms ' + easing,
                overflow: 'hidden'
            }, style);


            switch (animateState) {
                case animateStates.WILLCLOSE:
                case animateStates.OPENING:
                    wrapperStyle.height = height + 'px';
                    break;

                case animateStates.WILLOPEN:
                case animateStates.CLOSING:
                case animateStates.DIDCLOSE:
                    wrapperStyle.height = minSize + 'px';
                    break;

                case animateStates.DIDOPEN:
                    wrapperStyle.height = 'auto';
                    wrapperStyle.overflow = 'visible';
                    break;

                case animateStates.CALCULATING:
                    if (removeOnCalc) {
                        wrapperStyle = Object.assign({}, wrapperStyle, {
                            height: 'auto',
                            position: 'absolute',
                            opacity: 0,
                            width: _this.getWidth()
                        });
                    } else {
                        wrapperStyle.height = 'auto';
                        wrapperStyle.opacity = 0;
                    }
                    break;
            }

            return wrapperStyle;
        };

        _this.animateStates = animateStates;

        _this.state = {
            height: null,
            animateState: _this.animateStates.DIDCLOSE
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    // requestAnimationFrame promisified


    // helper functions to set certain states


    // helper functions to is check certain state active

    // helper function to get height of ref element


    // helper functions that are chaining certain list of states to make full animation


    // handling the end of transition and setting component's state to the finishing of either directions


    // function to call needed callback when certain state was activated
    // took names from CSSTransition callbacks names


    // getting styles for animating wrapper div


    _createClass(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var children = this.props.children;

            children = _react.Children.toArray(children);

            if (children.length) {
                this.calculateAndOpen();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var nextChildren = nextProps.children,
                enter = nextProps.enter,
                exit = nextProps.exit,
                curChildren = _react.Children.toArray(this.props.children);

            nextChildren = _react.Children.toArray(nextChildren);

            // if nextChildren came and there's no current children
            if (!curChildren.length && nextChildren.length) {
                // if ui is one of three states (willClose, closing or didClose)
                if (this._isUiClose()) {
                    // if enter prop is true - animating enter
                    if (enter) {
                        // if component's children update when component is animating - we will animate it back without any
                        // calculation and special states
                        if (this._isUiClosing()) {
                            this._uiOpening();
                            // if component will animate or did animate - calculating and animating it
                        } else if (this._isUiWillClose() || this._isUiDidClose()) {
                            this.calculateAndOpen();
                        }
                        // if enter is false - going to didOpen state immediately
                    } else {
                        this._uiDidOpen();
                    }
                }

                // if curChildren exist and curChildren didn't came
            } else if (curChildren.length && !nextChildren.length) {
                // if ui is one of three states (willOpen, opening or didOpen)
                if (this._isUiOpen()) {
                    // if exit prop is true - animating exit
                    if (exit) {
                        // if component's children update when component is animating - we will animate it back without any
                        // calculation and special states
                        if (this._isUiOpening()) {
                            this._uiClosing();
                            // if component will animate or did animate - calculating and animating it
                        } else if (this._isUiWillOpen() || this._isUiDidOpen()) {
                            this.calculateAndClose();
                        }
                        // if exit is false - going to didClose state immediately
                    } else {
                        this._uiDidClose();
                    }
                }
            }
        }
    }]);

    return Main;
}(_Component3.default);

Main.defaultProps = {
    minSize: 0,
    timeout: _variables2.default.transitionDurationNumber,
    easing: _variables2.default.transitionFunction,
    enter: true,
    exit: true,
    removeOnCalc: true,
    childFactory: function childFactory(child) {
        return child;
    }
};
Main.propTypes = {
    minSize: _propTypes2.default.number,
    timeout: _propTypes2.default.number,
    easing: _propTypes2.default.string,
    children: _propTypes2.default.any,
    enter: _propTypes2.default.bool,
    exit: _propTypes2.default.bool,
    onEnter: _propTypes2.default.func,
    onEntering: _propTypes2.default.func,
    onEntered: _propTypes2.default.func,
    onExit: _propTypes2.default.func,
    onExiting: _propTypes2.default.func,
    onExited: _propTypes2.default.func,

    // флаг обозначает нужно ли убирать компонент из-за экрана при расчете высоты
    removeOnCalc: _propTypes2.default.bool,

    // childFactory нужна для необычного кейса. Если нужно отрендерить child и изменять его props после unmount
    // (когда рендерятся child из state TransitionGroup'a) нужно использовать эту ф-цию. Она должна возвращать JSX
    // компонент в разметке <Component/> со всеми props которые нужно передать внутрь, в том числе и измененные
    // Пример: () => <TestComponent propToPass='prop' propToChange='anotherProp'/>
    childFactory: _propTypes2.default.func
};
Main.displayName = 'AnimateHeight';
exports.default = Main;